import React, { useEffect } from 'react';
import { message } from 'antd';

// import recoil stuff
import { useRecoilState } from 'recoil';
import { metamaskState } from 'global/state';
import { Network } from 'components/utils';



function MetamaskEvents() {
  const [ metamask, setMetamask ] = useRecoilState(metamaskState);

  const detectMetamaskChange = () => {
    if (window.ethereum) {

      window.ethereum.on('networkChanged', async function(network) {
        const networkId = parseInt(network);
        if ( networkId !== Network.BSC && networkId !== Network.ETHEREUM ) {
          message.error('Error: You switched to a non-supported network,. Please select Ethereum or BSC network.');
          setMetamask({ connected: false, address: '', network: '' })
          return;
        }
        const response = await window.ethereum.enable();
        const address = response[0];
        setMetamask({
          connected: true,
          network: networkId,
          address: address,
        });
      });

      // detect Metamask account change
      window.ethereum.on('accountsChanged', function(accounts) {
        const address = accounts[0];
        setMetamask({
          ...metamask,
          address: address,
        });

      });

    }
  }


  // setup useEffect to detect metamask changes.
  useEffect( () => {
    const detect = detectMetamaskChange();
    return detect;
  }, []);


  return null;

}

export default MetamaskEvents;
